import { trackClientEvent } from 'analytics/analytics'

import { CONTENT_SECTION_IDS } from './constants'

const READ_MORE_TRACKING_MAP: Record<string, string> = {
  [CONTENT_SECTION_IDS.location]: 'offer_page_read_more_location',
  [CONTENT_SECTION_IDS.highlights]: 'offer_page_read_more_highlights',
  [CONTENT_SECTION_IDS.facilities]: 'offer_page_read_more_facilities',
  [CONTENT_SECTION_IDS.finePrint]: 'offer_page_read_more_fine_print',
}

export function maybeTrackReadMoreClientEvent(id: string, isOpening: boolean) {
  if (READ_MORE_TRACKING_MAP[id]) {
    const subject = isOpening ? READ_MORE_TRACKING_MAP[id] : `${READ_MORE_TRACKING_MAP[id]}_close`
    trackClientEvent({
      subject,
      action: 'click',
      category: 'offer page',
      type: 'interaction',
    })
  }
}
